/**
 * @description 业务拨测 dial
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const dialBiz = new Logic()

dialBiz.findAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.findAll,
    data: data
  })
}

dialBiz.checkTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.checkTask,
    data: data
  })
}

dialBiz.getDetail = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.getDetail,
    data: data
  })
}

dialBiz.getDetailList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.getDetailList,
    data: data
  })
}

dialBiz.deleteTask = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.deleteTask,
    data: data
  })
}

dialBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.save,
    data: data
  })
}

dialBiz.start = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.start,
    data: data
  })
}

dialBiz.stop = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.stop,
    data: data
  })
}

dialBiz.testall = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.testall,
    data: data
  })
}

dialBiz.testTerminalLogin = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.testTerminalLogin,
    data: data
  })
}

dialBiz.getDialById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.getDialById,
    data: data
  })
}

dialBiz.update = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dial.update,
    data: data
  })
}

export default dialBiz
